import settings from './config.json';
import { parseISO, format } from "date-fns";
const ConfigHolder = {
    api_server: settings.api_server,
    build: settings.build,
    get apiBaseUrl() {
        var _a, _b;
        return (_b = (_a = process.env) === null || _a === void 0 ? void 0 : _a.UPLOAD_DOMAIN) !== null && _b !== void 0 ? _b : '';
    },
    get oauthDomainUrl() {
        var _a, _b;
        return (_b = (_a = process.env) === null || _a === void 0 ? void 0 : _a.OAUTH_DOMAIN) !== null && _b !== void 0 ? _b : '';
    },
    getApiMethodUrl(api_key, widget_id, method, group) {
        var _a, _b;
        if (!group)
            group = 'public';
        let url = new URL(`${(_b = (_a = process.env) === null || _a === void 0 ? void 0 : _a.WIDGET_API_CONFIG_URL) !== null && _b !== void 0 ? _b : ''}/${api_key}/${group}/${method}`, ConfigHolder.apiBaseUrl);
        if (widget_id) {
            url.searchParams.set('widget_id', widget_id);
        }
        // let api_salt: number = Date.now()
        // url.searchParams.set('api_format', 'json')
        // url.searchParams.set('api_lang', 'nl')
        // url.searchParams.set('api_salt', api_salt.toString())
        // url.searchParams.set('applicationId', process.env?.YII_API_APPLICATION_ID ?? 'widget-booking')
        // url.searchParams.set('api_key', api_key)
        return url;
    },
    get tokenString() {
        let _token = JSON.parse(window.localStorage.getItem('token') || '{}');
        return _token === null || _token === void 0 ? void 0 : _token.token;
    },
    get currentUser() {
        let _token = JSON.parse(window.localStorage.getItem('token') || '{}');
        return _token === null || _token === void 0 ? void 0 : _token.currentUser;
    },
    get buildNumber() {
        //@ts-ignore
        let date = parseISO(process.env.BUILD_DATE);
        //@ts-ignore
        return process.env.BUILD_TYPE.concat('.').concat(format(date, 'yy.LLdd.HHmm'));
    }
};
export default ConfigHolder;
